import { StepsHeader } from '../../Common/StepsHeader/stepsHeader'
import {
    Details,
    CharacterCount,
    CountText,
    ErrorBlockSmall,
    courseDetailsSx,
} from '../styles'
import { ShowErrorToast } from '../../Common/Toast/toast'
import { Box, useMediaQuery, useTheme } from "@mui/material";
import "react-quill/dist/quill.snow.css";
import Grid from "@mui/material/Unstable_Grid2/Grid2";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import ReactQuill from "react-quill";
import {
  StyledTextField
} from '../../../Infrastructure/Theme/styledComponents';
import { useFormik } from "formik";
import { httpsCallable } from "firebase/functions";
import * as Yup from "yup";
import { functions } from '../../../Infrastructure/config';
import { Loader } from '../../Common/Loader/loader';
import { incrementCoursesSteps, decrementCoursesSteps } from '../../../Infrastructure/States/coursesStepsSlice';
import { StepsFooter } from '../../Common/StepsFooter/stepsFooter';
import '../styles'
import { ImageCropComponent } from '../../Common/ImageCropComponent/ImageCropComponent';
import { cleanCourseState } from '../../../Infrastructure/States/courseDetailsSlice';
import { setCourseDetails } from '../../../Infrastructure/States/courseDetailsSlice';
import '../styles.css'
import ERROR_CONSTANTS from '../../../Infrastructure/Constants/errorConstants';
import useAuthentication from '../../../Infrastructure/States/onAuthStateChange';
import { formats, modules } from '../../../Infrastructure/Constants/reactQuillConstants';
import paths from '../../../Infrastructure/Router/paths';
import { USER_LOGS_CLIENT } from '../../../Infrastructure/Constants/logsConstant';
import { safeClientLogEvent } from '../../../Infrastructure/Utilities/safeClientLogEvent';

export const CourseDetails = () => {
    const theme = useTheme();
    const minCharacters = 200;
    const maxCharacters = 10000;
    const errorRef = useRef(null);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { pathname } = useLocation()
    const { userId } = useAuthentication()
    const ip = useSelector((state) => state.ip.address)
    const [scrollTrigger, setScrollTrigger] = useState(0);
    const page = useSelector((state)=> state.route.currentRoute)
    const isXs = useMediaQuery(theme.breakpoints.down('sm'));
    const [loaderValue, setLoaderValue] = useState(false);
    const userData = useSelector((state) => state.userData.data)
    const loading = useSelector((state) => state.userData.loading);
    const course = useSelector((state) => state.course.courseDetails)
    const courseDetails = course?.course?.courseDetails?.details || {}
    const courseId = course?.courseId || null
    const courseImageUrl = courseDetails?.course_image;
    const description = courseDetails?.description
    const promoLink = courseDetails?.promo_link;
    const [croppedImage, setCroppedImage] = useState("");
    const [characterCount, setCharacterCount] = useState(0);
    const [htmlData, setHtmlData] = useState(description || "");
    const [errorMessage, setErrorMessage] = useState("");
    const courseSteps = useSelector((state) => state.courseSteps.courseSteps)
    // Define the isUrlValid function
    function isUrlValid(userInput) {
        if (!userInput) return false;
        const pattern = /^(https?:\/\/)?(www\.)?[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+([/?#].*)?$/;
        return pattern.test(userInput.trim());
    }
    function ensureHttpsProtocol(url) {
        if (url && !url.startsWith("https://")) {
            return "https://" + url;
        }
        return url;
    }
    const formik = useFormik({
        initialValues: {
            description: "",
            courseImage: courseImageUrl ? '' : croppedImage,
            promoLink: ensureHttpsProtocol(promoLink) || "",
            courseId: courseId || ''
        },
        validationSchema: Yup.object().shape({
            promoLink: Yup.string()
            .nullable()
            .test("promoLink", "Invalid promo link URL", (value) => {
            if (!value || value.trim() === "") return true
            return isUrlValid(value)
            })
        }),
        onSubmit: async (values) => {
            setErrorMessage('')
            let newDisplayMessage = "";
            if (
                characterCount < minCharacters ||
                characterCount > maxCharacters
            ) {
                newDisplayMessage = `Course description must be ${minCharacters}-${maxCharacters} characters`;
                setErrorMessage(newDisplayMessage);
            }
            else {
                newDisplayMessage = "";
                if (newDisplayMessage) {
                    setLoaderValue(false);
                    return;
                }
                try {
                    setLoaderValue(true);
                    const updateCourseDetailsStep = httpsCallable(
                        functions,
                        "updatecoursedetailsstep"
                    );
                    await updateCourseDetailsStep({...values, ip, page});
                    const course = userData?.educator?.courses[courseId ? courseId : ''];
                    if (course) {
                        dispatch(setCourseDetails({ course, courseId }));
                    }
                    dispatch(incrementCoursesSteps());
                } catch (error) {
                    ShowErrorToast(ERROR_CONSTANTS.GENERIC_ERROR_TOAST);
                    await safeClientLogEvent({
                        ...USER_LOGS_CLIENT.COURSE_DETAILS_STEP_UPDATE_FAILED,
                        uid: userId || null,
                        source: "courseDetailsStep.jsx",
                        emailInfo: null,
                        metadata: null,
                        error: error?.message || null
                        });
                } finally {
                    setLoaderValue(false);
                }
            }
        },
    });
    const handleDec = async () => {
        try {
            setLoaderValue(true);
            const updateCourseDetailsStep = httpsCallable(
                functions,
                "updatecoursedetailsstep"
            );
            await updateCourseDetailsStep({ ...formik.values, step: 3, ip, page });
            const course = userData?.educator?.courses[courseId ? courseId : ''];
            if (course) {
                dispatch(setCourseDetails({ course, courseId }));
            }
            dispatch(decrementCoursesSteps());
        } catch (error) {
            ShowErrorToast(ERROR_CONSTANTS.GENERIC_ERROR_TOAST);
            await safeClientLogEvent({
                ...USER_LOGS_CLIENT.COURSE_DETAILS_STEP_DECREMENT_FAILED,
                uid: userId || null,
                source: "courseDetailsStep.jsx",
                emailInfo: null,
                metadata: null,
                error: error?.message || null
            });
        } finally {
            setLoaderValue(false)
        }
    };
    const handleContinueClick = async () => {
        //  1: check description length
        if (characterCount < minCharacters || characterCount > maxCharacters) {
            setErrorMessage(`Course description must be ${minCharacters}-${maxCharacters} characters`);
            setScrollTrigger(prev => prev + 1);
            return;
        }
        // step 3: clear errors and submit
        setErrorMessage("");
        formik.handleSubmit()
    };
    function countCharactersWithoutTags(html) {
        const textWithoutTags = html.replace(/(<([^>]+)>)/gi, "");
        return textWithoutTags.length;
    }
    const handleCourseDetailsChange = (value) => {
        const currentCharacterCount = countCharactersWithoutTags(value);
        setCharacterCount(currentCharacterCount);
        formik.setFieldValue("description", value);
        setHtmlData(value);
    };
    useEffect(() => {
        if ((croppedImage || courseImageUrl) && errorMessage === "Course image required") {
            setErrorMessage("");
        }
        if (characterCount >= minCharacters && characterCount <= maxCharacters &&
            errorMessage.includes("Course description")) {
            setErrorMessage('');
        }
    }, [croppedImage, courseImageUrl, characterCount, errorMessage]);

    const handleExit = async () => {
        try {
            setLoaderValue(true)
            const updateCourseDetailsStep = httpsCallable(
                functions,
                "updatecoursedetailsstep"
            );
            await updateCourseDetailsStep({ ...formik.values, step: 4, ip, page });
            navigate(paths.dashboardPage.path);
        } catch (error) {
            navigate(paths.dashboardPage.path);
            ShowErrorToast(ERROR_CONSTANTS.GENERIC_ERROR_TOAST);
            await safeClientLogEvent({
                ...USER_LOGS_CLIENT.COURSE_DETAILS_STEP_UPDATE_FAILED,
                uid: userId || null,
                source: "courseDetailsStep.jsx",
                emailInfo: null,
                metadata: null,
                error: error?.message || null
            });
        } finally {
            dispatch(cleanCourseState())
            setLoaderValue(false)
        }
    };
    useEffect(() => {
        setCharacterCount(formik.values.description.length);
    }, [formik.values.description]);
    useEffect(() => {
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = htmlData;
        const text = tempDiv.textContent || tempDiv.innerText;
        setCharacterCount(text.length);
    }, [htmlData]);
    useEffect(() => {
        document.documentElement.scrollTop = 0
        document.body.scrollTop = 0
    }, [pathname])

    useEffect(() => {
        if (errorMessage && isXs && errorRef.current) {
            errorRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
        }
    }, [scrollTrigger, isXs, errorMessage]);

    return (
        <Box sx={courseDetailsSx.root}>
            <Box sx={courseDetailsSx.headerBox}>
                <StepsHeader steps={courseSteps} handleExit={handleExit} />
            </Box>
            {loading || loaderValue ? (
                <Loader />
            ) : (
                <Box
                    component={"form"}
                    onSubmit={formik.handleSubmit}
                    sx={courseDetailsSx.content}
                >
                    <Grid
                        container
                        sx={courseDetailsSx.mainGridBox}
                    >
                        <Grid
                            lg={7}
                            md={12}
                            sm={12}
                            xs={12}
                            sx={courseDetailsSx.subGrid1Box}
                            order={{ lg: 1, md: 2, sm: 2, xs: 2 }}
                        >
                            <Box
                                sx={courseDetailsSx.quillBox}
                                className={"react_quill"}
                            >
                                <Details color={"primary"}>
                                    Course description
                                </Details>
                                <ReactQuill
                                    theme="snow"
                                    modules={modules}
                                    formats={formats}
                                    value={htmlData}
                                    onChange={handleCourseDetailsChange}
                                    style={{
                                        marginTop: "20px",
                                    }}
                                    className="react_quill_border"
                                />
                            </Box>
                            <Box width={"100%"}>
                                <CharacterCount>
                                    Character Count: <CountText>{characterCount}</CountText>
                                </CharacterCount>
                            </Box>
                        </Grid>
                        <Grid
                            lg={5}
                            md={12}
                            sm={12}
                            xs={12}
                            sx={courseDetailsSx.subGrid2Box}
                            order={{ lg: 2, md: 1, sm: 1, xs: 1 }}
                        >
                            <Box sx={courseDetailsSx.imageBox} >
                                <ImageCropComponent setCroppedImage={setCroppedImage} courseImageUrl={courseImageUrl} formik={formik} croppedImage={croppedImage} />
                                <StyledTextField
                                    name="promoLink"
                                    sx={courseDetailsSx.promoLinkTextField} 
                                    variant="standard"
                                    {...formik.getFieldProps("promoLink")}
                                    placeholder="www.promoLink.com"
                                    label={
                                        formik.errors.promoLink
                                            ? `${formik.errors.promoLink}`
                                            : "Promotional Video Link (Optional)"
                                    }
                                    error={
                                        formik.touched.promoLink && Boolean(formik.errors.promoLink)
                                    }
                                    fullWidth
                                />
                            </Box>
                        </Grid>
                    </Grid>
                    <ErrorBlockSmall sx={courseDetailsSx.error} ref={errorRef}>
                        {errorMessage}
                    </ErrorBlockSmall>
                </Box>
            )}
            <Box sx={courseDetailsSx.footerBox}>
                <StepsFooter handleDec={handleDec} handleContinueClick={handleContinueClick} error={errorMessage} isLoading={loaderValue} />
            </Box>
        </Box>
    );
};











